import styled from "@emotion/styled";
import {JobLinksRenderer, TJobLinkItem} from "../../common/JobLinksRenderer";

export type TUnsupportedJobDetails = TJobLinkItem;

export interface UnsupportedJobTypesContentProps {
  multiplePickupsAndDeliveriesJobs: TUnsupportedJobDetails[];
  bothStopJobs: TUnsupportedJobDetails[];
}

const UnsupportedJobTypesContent = ({
  bothStopJobs,
  multiplePickupsAndDeliveriesJobs
}: UnsupportedJobTypesContentProps) => {
  return (
    <Container>
      <List>
        {multiplePickupsAndDeliveriesJobs.length > 0 && (
          <li>
            Job {JobLinksRenderer(multiplePickupsAndDeliveriesJobs)}{" "}
            {multiplePickupsAndDeliveriesJobs.length > 1 ? "contain" : "contains"} 2+ Pickups & 2+ Deliveries
          </li>
        )}
        {bothStopJobs.length > 0 && (
          <li>
            Job <>{JobLinksRenderer(bothStopJobs)}</> {bothStopJobs.length > 1 ? "contain" : "contains"} Both stops
          </li>
        )}
      </List>
      These jobs will be un-selected automatically after this dialog is closed.
    </Container>
  );
};

export default UnsupportedJobTypesContent;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const List = styled.ul`
  margin: 0;
  padding-left: 16px;
  & > li:not(:last-of-type) {
    margin-bottom: 12px;
  }
`;
